export function getToken() {
    return localStorage.getItem("Token")
}

export function setToken(token) {
    return localStorage.setItem("Token", token)
}

export function removeToken() {
    return localStorage.removeItem('Token')
}
export function aad() {
    let time = sessionStorage.getItem("time");
    if(!time) return;
    var crypto = require('crypto');
    var sign=crypto.createHmac('sha1', 'temp123456_bpt_ybtong').update(time).digest().toString('base64');
    // str = (str + '').toString();   

    return encodeURIComponent(sign).replace(/!/g, '%21').replace(/'/g, '%27').replace(/\(/g, '%28').  
    replace(/\)/g, '%29').replace(/\*/g, '%2A').replace(/%20/g, '+');  
    
}
export function isLogin(){
    if(!sessionStorage.getItem("tokeid") || !sessionStorage.getItem("id")){
        alert("请先登录!");
        return false
    }else{
        return true;
    }
}


// WEBPACK FOOTER //
// ./src/utils/auth.js